import type { FaireProductEntity } from "../../entity_types/product";

export const p_adpe2yzfxj: FaireProductEntity = {
  token: "p_adpe2yzfxj",
  type: "product",
  name: "Second Chance Dry Shampoo - Travel Size",
  brandToken: "b_9jbcq5zd5m",
  brandName: "The Beachwaver Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8d524b90686ce00726c647087fc73877429b52fc37fb2f8b37017f7845a42d62.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1905bf479dde453c27b99199da7d010bb54afb5b39d39b60f452b6e757ee2a98.jpeg",
    "https://cdn.faire.com/fastly/7058fd2d78b691b65d54832a9df999bd950338a2394f07f280bdfa9c529efd1e.jpeg",
    "https://cdn.faire.com/fastly/a9a896936dbb73b4615a16706bff24296989b3e7b35275c6ffd94ad88d523a0c.jpeg",
    "https://cdn.faire.com/fastly/371128a4ae1f543d7d8540cc36e83a307d7742e9ed25f7453d523eb1882882f3.jpeg",
    "https://cdn.faire.com/fastly/0f4e5d704db8106544a9bb59f4f2e05295722d997a7ecc79818d66194116eac7.jpeg",
    "https://cdn.faire.com/fastly/6a13391622650695de9f26a5265a818d2dc883dbbd940111332a000967dface2.jpeg",
  ],
  priceDollars: 6,
  description:
    "With everything you love about your favorite dry shampoo in a petite package, keep Second Chance with you at all times! This smaller version is perfect for travel or to keep in your bag for quick touch-ups throughout the day!\nGive your hair a second chance with our oil-absorbing Dry Shampoo. This rice-based formula will revive your hair and restore fullness to your roots. \n\nRice formula absorbs oil allowing you to extend your style for days.  \n\n· Extends wave life \n· Absorbs moisture \n· Adds volume \n\nAroma Experience:\nBrazilian Berry: Soak in this fresh and fruity blend of sun-kissed Brazilian blackberries, French apricots and flowering jasmine sambac. Balanced with Tahitian Vanilla and Polynesian coconut, this fragrance is bright and breezy, like a warm summer day.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:00.050Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
